<template>
  <header class="client-header">
    <div class="container">
      <div class="client-header__wrap">
        <a href="#" class="client-header__logo">
          <img src="../assets/img/logo.png" alt="logo" style="width: 40px;">
        </a>
        <div class="client-header__mobile-wrap">
          <button class="client-header__type" type="button">
            <span>{{currentRoute}}</span>
            <i class="material-icons">chevron_left</i>
            <div class="client-header__pages">
              <router-link :to="'/company/' + companyId" class="client-header__page-item">выбор филиала</router-link>
              <router-link
                v-if="companySettings && companySettings.is_genderable_services"
                :to="`/company/${cid}/${sid}/client-gender`"
                class="client-header__page-item"
              >
                Выбор пола
              </router-link>
              <router-link :disabled="checkParamsGender" tag="button" :to="`/company/${cid}/${sid}/client-service`" class="client-header__page-item" >Выбор услуги </router-link>
              <router-link :disabled="checkParamsServices" tag="button" :to="`/company/${cid}/${sid}/client-masters`" class="client-header__page-item">Выбор мастера</router-link>
              <router-link :disabled="checkParamsMaster" tag="button" :to="`/company/${cid}/${sid}/client-confirm`" class="client-header__page-item">Подтверждение записи</router-link>
            </div>
          </button>
          <div class="client-header__address">м. {{ salonMetro }}, {{ salonAddress }}</div>
        </div>
        <a href="#" class="client-header__cart">
          <i class="material-icons">shopping_cart</i>
          <span>{{selectedServices.length}}</span>
          <div v-if="selectedServices.length > 0" class="client-header__cart-items">
            <OneCartItem
              v-for="(service, index) in selectedServices"
              :service="service"
              :idx="index"
              :key="index"
            ></OneCartItem>
            <div class="client-header__cart-sum">
              Итого: {{finalCost}}₽
            </div>
          </div>
        </a>
      </div>
    </div>
  </header>
</template>

<script>
import OneCartItem from "@/components/OneCartItem/OneCartItem.vue";

import { mapGetters, mapState } from "vuex";
export default {
  name: "client-header",
  props: ["cid","sid"],
  data() {
    return {
        currentRoute: null,
        routerLocalization: {
            "client-company":  "выбор филиала",
            "client-priority": "Выбор приоритета",
            "client-gender": "Выбор пола",
            "client-choose": "Дата и время",
            "client-masters": "Выбор мастера",
            "client-confirm": "Подтверждение записи",
            "client-service": "Выбор услуги"
        }
    }
  },
  components: {
    OneCartItem
  },
  computed: {
    ...mapState("client", ["currentSalonId", "selectedServices", "companyId", "companySettings", "serviceInProgress", "customer"]),
    ...mapGetters("salons", ["getSalon"]),
    ...mapGetters("client", ["finalCost"]),
    salon() {
      return this.getSalon(this.currentSalonId);
    },
    salonMetro() {
      return this.salon ? this.salon.metro : "";
    },
    salonAddress() {
      return this.salon ? this.salon.address : "";
    },
    checkParamsGender() {
      return (this.customer && this.customer.gender.length <= 0 && this.companySettings && this.companySettings.is_genderable_services) || false
    },
    checkParamsServices() {
      return !(this.serviceInProgress && Number.isInteger(this.serviceInProgress.serviceId)) || false
    },
    checkParamsMaster() {
      return !(this.serviceInProgress && Number.isInteger(this.serviceInProgress.masterId)) || false
    }
  },
  mounted: function() {
    this.$nextTick(function() {
        this.currentRoute  = this.routerLocalization[this.$route.name];
    });

  }
};
</script>

<style lang="sass">
$mobile-s: 375
$mobile: 568
$tablet: 767
$desktop: 992
$wide: 1336
$hd: 1440

// COLORS
$text-18: #181818
$text-36: #363636

// OPTIONS
$transitSpeed: .2s
$ease: ease-in-out

// SOCIALS
$twitter: #00aced
$facebook: #3b5998
$googleplus: #dd4b39
$pinterest: #cb2027
$linkedin: #007bb6
$youtube: #bb0000
$vimeo: #1ab7ea
$tumblr: #32506d
$instagram: #bc2a8d
$flickr: #ff0084
$dribbble: #ea4c89
$quora: #a82400
$foursquare: #0072b1
$forrst: #5B9A68
$vk: #45668e
$wordpress: #21759b
$stumbleupon: #EB4823
$yahoo: #7B0099
$blogger: #fb8f3d
$soundcloud: #ff3a00

// width
=r($width)
  @media only screen and (max-width: $width+ "px")
    @content

=rmin($width)
  @media only screen and (min-width: $width+ "px")
    @content

// height
=rh($height)
  @media only screen and (max-height: $height + "px")
    @content

=rhmin($height)
  @media only screen and (min-height: $height + "px")
    @content
//Client header styles
.client-header
  padding: 15px 0
  background-color: #fff
  &__wrap
    display: -webkit-flex
    display: -ms-flex
    display: flex
    justify-content: flex-start
    align-items: center
  &__logo
    display: inline-block
    width: 44px
    height: 40px
    margin-right: 20px
  &__mobile-wrap
    display: -webkit-flex
    display: -ms-flex
    display: flex
    justify-content: space-between
    align-items: center
    margin-right: auto
    flex-grow: 1
  &__type
    font-size: 14px
    line-height: 18px
    border: 0
    padding: 7px 0
    background-color: transparent
    color: $text-18
    position: relative
    flex: 0 0 auto
    margin-right: 20px
    i
      display: inline-block
      vertical-align: middle
      transform: rotate(-90deg)
      font-size: 18px
      position: relative
      top: -1px
    &:hover
      .client-header__pages
        visibility: visible
        opacity: 1
        transform: translateY(0px)
  &__address
    margin-left: auto
    margin-right: 30px
    color: $text-36
    font-size: 16px
  &__cart
    position: relative
    display: inline-block
    color: $text-36
    font-size: 14px
    span
      position: absolute
      top: -5px
      right: -5px
      width: 12px
      height: 12px
      background-color: #fff
      border-radius: 50%
      font-size: 9px
      text-align: center
      display: flex
      justify-content: center
      align-items: center
      color: $text-18
    &-items
      position: absolute
      top: calc(100% + 5px)
      right: 0
      width: 100%
      min-width: 300px
      background-color: #fff
      border-radius: 8px
      padding: 5px
      box-shadow: 0 0 15px rgba(0,0,0,0.1)
      z-index: 20
      transition: all $transitSpeed
      transform: translateY(-20px)
      opacity: 0
      visibility: hidden
      &.is-active,
      &:hover
        visibility: visible
        opacity: 1
        transform: translateY(0px)
    &-sum
      color: #4D4D4D
      font-size: 14px
      font-weight: 500
      margin-top: 10px
      margin-bottom: 10px
      padding-left: 20px
    &-item
      padding-top: 10px
      border-bottom: 1px solid #4D4D4D
      &:last-child
        border-bottom: none
    &-service
      &-name
        color: #4D4D4D
        font-size: 14px
        font-weight: 500
        margin-top: 0
        margin-bottom: 10px
        padding-left: 20px
      &-type
          color: #4D4D4D
          font-size: 12px
          margin-bottom: 20px
          margin-top: 0
          font-weight: 400
          padding-left: 20px
      &-param
          color: #4D4D4D
          font-size: 12px
          margin-bottom: 20px
          margin-top: 0
          font-weight: 400
          padding-left: 20px
    &:hover
      .client-header__cart-items
        visibility: visible
        opacity: 1
        transform: translateY(0px)
  &__pages
    position: absolute
    top: calc(100% + 5px)
    left: 0
    width: 100%
    min-width: 240px
    background-color: #fff
    border-radius: 8px
    padding: 5px
    box-shadow: 0 0 15px rgba(0,0,0,0.1)
    z-index: 20
    transition: all $transitSpeed
    transform: translateY(-20px)
    opacity: 0
    visibility: hidden
    &.is-active,
    &:hover
      visibility: visible
      opacity: 1
      transform: translateY(0px)
  &__page-item
    display: block
    width: 100%
    background: transparent
    border: none
    outline: none
    box-shadow: none
    font-size: 14px
    font-weight: 400
    color: $text-18
    padding: 15px 10px
    text-align: left
    border-radius: 8px
    transition: all $transitSpeed
    margin-bottom: 5px
    &[disabled=disabled]
      opacity: 0.5
      cursor: default
    &:last-child
      margin-bottom: 0
    &.router-link-exact-active
      &[disabled=disabled]
        border: 1px solid $text-36
    &.is-active, &.router-link-exact-active,
    &:hover
      &:not([disabled=disabled])
        color: #fff
        background-color: $text-36
    &.is-disable
      opacity: 0.5
      pointer-events: none
      &:hover
        cursor: default
        background-color: #fff
        color: $text-18

+r($tablet)
  .client-header
    &__logo
      margin-right: 13px
    &__mobile-wrap
      flex-direction: column
      align-items: flex-start
    &__type
      font-size: 12px
      padding: 3px 0
      i
        display: inline-block
        font-size: 16px
    &__address
      margin-left: 0
      font-size: 12px
      color: #DADADA
      margin-right: 0
      margin-top: 5px
    &__cart
      display: none

@media(max-width: 360px)
  .client-header__pages
    left: -10px
    min-width: 230px


</style>
